export default __webpack_public_path__ + "c0900210dc95690f8b8af6818dd47636.svg";